import { TableHeaderCellElement } from './styles';

interface Props {
    title?: React.ReactNode;
    columnAlignment?: string;
}

const SimpleTableHeaderCell = ({ columnAlignment, title }: Props) => (
    <TableHeaderCellElement columnAlignment={columnAlignment}>{title}</TableHeaderCellElement>
);

export default SimpleTableHeaderCell;
